import MaskedLine from "@/components/MaskedLine";
import { motion } from "framer-motion";

const PageHero = ({ overline, lines, intro, id }) => (
  <section className="relative bg-pine text-cream grain overflow-hidden" data-testid={`${id}-hero`}>
    <div className="relative z-10 mx-auto max-w-7xl px-5 sm:px-8 pt-40 pb-20 sm:pt-48 sm:pb-28">
      <motion.p
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.15 }}
        className="text-xs font-semibold tracking-[0.32em] uppercase text-gold mb-7"
      >
        {overline}
      </motion.p>
      <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl font-medium leading-[1.04] tracking-tight max-w-4xl">
        {lines.map((line, i) => (
          <MaskedLine key={line} delay={0.25 + i * 0.12}>
            {line}
          </MaskedLine>
        ))}
      </h1>
      {intro && (
        <motion.p
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.75 }}
          className="mt-8 max-w-2xl text-base sm:text-lg text-cream/70 leading-relaxed"
        >
          {intro}
        </motion.p>
      )}
    </div>
    <div className="absolute -right-24 -top-24 h-80 w-80 rounded-full border border-gold/20" aria-hidden="true" />
    <div className="absolute -right-10 -top-10 h-48 w-48 rounded-full border border-cream/10" aria-hidden="true" />
  </section>
);

export default PageHero;
